import { Grid, Tooltip } from "@mui/material";
import React, { FC } from "react";
import GeneralListItem from "@/components/general/generaListItem";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import styles from "@/components/appointmentRequest/timeSlotItem.module.css";

interface Props {
  slotData: any;
  handleToggleDisabled: (slot: any, disabled: any) => void;
  loading?: any;
}

const TimeSlotItem: FC<Props> = ({
  slotData,
  handleToggleDisabled,
  loading,
}) => {
  const { t } = useTranslation();
  const slotTaken = slotData.appointment !== null;
  const slotDisabled = slotData.disabled === true;
  const slotTime =
    dayjs(slotData.start_date).format("HH:mm") +
    " - " +
    dayjs(slotData.end_date).format("HH:mm");
  const toolTipTitle = slotDisabled
    ? t("timeslot_disabled")
    : slotTaken
    ? t("timeslot_taken")
    : t("timeslot_available");

  return (
    <Grid
      item
      key={slotData.id}
      xs={6}
      sm={4}
      md={3}
      lg={2}
      className={styles.slotGridItem}
    >
      <Tooltip
        arrow
        placement="top"
        title={toolTipTitle}
        enterDelay={1000}
        enterNextDelay={250}
      >
        <span
          className={styles.slotTooltipAnchor}
          onClick={() => {
            if (!slotTaken && !loading) {
              handleToggleDisabled(slotData, slotDisabled);
            }
          }}
        >
          <GeneralListItem
            allowHover={!slotTaken && true}
            hideButton={true}
            margin="0"
            wrapperStyle={{ width: "100%" }}
            wrapperClassName={`
              ${styles.generalListItemWrapper}
              ${slotDisabled ? styles.generalListItemWrapper__slotDisabled : ""}
              ${
                !slotDisabled && slotTaken
                  ? styles.generalListItemWrapper__slotTaken
                  : ""
              }
              ${
                !slotDisabled && !slotTaken
                  ? styles.generalListItemWrapper__slotFree
                  : ""
              }
            `}
            contentClassName={`${
              slotDisabled ? styles.generalListItemContent__slotDisabled : ""
            }`}
          >
            {slotTime}
          </GeneralListItem>
        </span>
      </Tooltip>
    </Grid>
  );
};

export default TimeSlotItem;
